import React, { useState, useEffect } from 'react';
import { func } from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';

import { addErrorMessageAction, setTaskFulfilled, setTaskPending } from '../../actions';
import Pagination from '../Pagination';
import styles from './permissionManagement.module.css';
import frontPageStyles from '../FrontPage/frontPage.module.css';
import { getUsersPage } from '../../api';
import { langType } from '../../constants/types';
import { withLang } from '../../i18n';
import UserSearch from './UserSearch';
import UserRow from './UserRow';
import useTitle from '../../hooks/useTitle';
import { EMPTY_PAGE } from '../../constants';

const USERS_PER_PAGE = 10;

const PermissionManagement = ({
  dispatchAddErrorMessage, dispatchSetTaskPending, dispatchSetTaskFulfilled, translate: t
}) => {
  const [usersPageParams, setUsersPageParams] = useState({
    query: null,
    queryTarget: null,
    roles: []
  });
  const [usersPage, setUsersPage] = useState(EMPTY_PAGE);

  async function getPage(page) {
    dispatchSetTaskPending();
    await getUsersPage(page, USERS_PER_PAGE, usersPageParams.query, usersPageParams.queryTarget, usersPageParams.roles, true)
      .then((uPage) => setUsersPage(uPage))
      .catch(dispatchAddErrorMessage)
      .finally(dispatchSetTaskFulfilled);
  }

  useTitle(`${t('adminTools.title')} - ${t('permissionManagement.title')}`);

  useEffect(() => {
    getPage(0);
  }, [usersPageParams]);

  const handleSearchCriteriaChange = (query, queryTarget, roles) => {
    setUsersPageParams({ query, queryTarget, roles });
  };

  return (
    <div className={frontPageStyles.content}>
      <h1 className="panel__title"><Translate id="permissionManagement.title" /></h1>
      <p><Translate id="permissionManagement.description" /></p>
      <UserSearch onCriteriaChange={handleSearchCriteriaChange} />

      <table className="table-simple">
        <thead className={styles.header}>
          <tr>
            <th><Translate id="common.username" /></th>
            <th><Translate id="common.name" /></th>
            <th><Translate id="common.email" /></th>
            <th><Translate id="common.studentNumber" /></th>
            <th><Translate id="permissionManagement.role" /></th>
          </tr>
        </thead>
        <tbody data-cy="admin-tools-page-users-list">
          {usersPage?.content?.map((user) => <UserRow user={user} key={user?.userId} />)}
        </tbody>
      </table>

      <Pagination
        navFunction={getPage}
        number={usersPage.number}
        totalPages={usersPage.totalPages}
        first={usersPage.first}
        last={usersPage.last}
      />

    </div>
  );
};

PermissionManagement.propTypes = {
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired,
  ...langType
};

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled())
});

export default withLang(connect(null, mapDispatchToProps)(PermissionManagement));
